module.exports = __webpack_public_path__ + "src/img/stopWatch/f627289191d58490969dd71f49c00b4d.png";